// A list's states and columns, edited — in the task dialog when a list is added, and in
// "מצבים ועמודות" for a list that exists. Controlled: `value` is { states, columns } as
// shapes.js builds it, and every change hands back a new one.
//
// Order is meaning for states: the first is where a new row starts, so each row can
// move up. A state's "טופל" says it finishes a row — the one fact the strip reads.
import he from '../../i18n/he';
import { SHAPE_KEYS, TONES, KINDS, localKey } from './shapes';
import { toneClass } from './ListGlance';
import { ArrowUpIcon, CloseIcon } from '../icons';

const L = he.lists;

const moveUp = (rows, i) => {
  if (i === 0) return rows;
  const next = [...rows];
  [next[i - 1], next[i]] = [next[i], next[i - 1]];
  return next;
};

const RowTools = ({ index, onUp, onRemove, canRemove }) => (
  <>
    <button type="button" className="icon-btn" onClick={onUp} disabled={index === 0} aria-label={L.moveUp} title={L.moveUp}><ArrowUpIcon /></button>
    <button type="button" className="icon-btn danger" onClick={onRemove} disabled={!canRemove} aria-label={L.removeRow} title={L.removeRow}><CloseIcon /></button>
  </>
);

export default function ListSetup({ value, onChange, shape, onShape, extraShapes, beforeStates }) {
  const set = (key, rows) => onChange({ ...value, [key]: rows });
  const edit = (key, i, patch) => set(key, value[key].map((r, j) => (j === i ? { ...r, ...patch } : r)));
  const drop = (key, i) => set(key, value[key].filter((_, j) => j !== i));

  return (
    <div className="list-setup">
      {onShape && (
        <div className="field">
          <span className="list-setup-label">{L.shape}</span>
          <div className="pills">
            {SHAPE_KEYS.map((k) => (
              <button key={k} type="button" className={`pill${shape === k ? ' on' : ''}`} onClick={() => onShape(k)}>
                {L.shapes[k].label}
              </button>
            ))}
            {extraShapes}
          </div>
        </div>
      )}

      {beforeStates}

      <div className="field">
        <span className="list-setup-label">{L.states}</span>
        {value.states.map((s, i) => (
          <div key={s.key} className={`setup-row ${toneClass(s.tone)}`}>
            <span className="dot" aria-hidden="true" />
            <select value={s.tone} onChange={(e) => edit('states', i, { tone: e.target.value })} aria-label={L.toneLabel}>
              {TONES.map((t) => <option key={t} value={t}>{L.tones[t]}</option>)}
            </select>
            <input value={s.label} maxLength={40} onChange={(e) => edit('states', i, { label: e.target.value })} aria-label={L.stateLabel} />
            <label className="setup-check">
              <input type="checkbox" checked={s.is_finished} onChange={(e) => edit('states', i, { is_finished: e.target.checked })} />
              {L.finished}
            </label>
            <RowTools index={i} onUp={() => set('states', moveUp(value.states, i))} onRemove={() => drop('states', i)} canRemove={value.states.length > 1} />
          </div>
        ))}
        {value.states.length < 12 && (
          <button type="button" className="add-pill" onClick={() => set('states', [...value.states, { key: localKey(), label: '', tone: 'gray', is_finished: false }])}>
            {L.addState}
          </button>
        )}
      </div>

      <div className="field">
        <span className="list-setup-label">{L.columns}</span>
        {value.columns.map((c, i) => (
          <div key={c.key} className="setup-row">
            <input value={c.label} maxLength={40} onChange={(e) => edit('columns', i, { label: e.target.value })} aria-label={L.columnLabel} />
            <select value={c.kind} onChange={(e) => edit('columns', i, { kind: e.target.value })} aria-label={L.kindLabel}>
              {KINDS.map((k) => <option key={k} value={k}>{L.kinds[k]}</option>)}
            </select>
            <RowTools index={i} onUp={() => set('columns', moveUp(value.columns, i))} onRemove={() => drop('columns', i)} canRemove />
          </div>
        ))}
        {value.columns.length < 12 && (
          <button type="button" className="add-pill" onClick={() => set('columns', [...value.columns, { key: localKey(), label: '', kind: 'text' }])}>
            {L.addColumn}
          </button>
        )}
      </div>
    </div>
  );
}
